export const guest = Symbol('Guest')
